import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5h3m4 0h9","key":"svg-0"}],["path",{"d":"M3 10h11m4 0h1","key":"svg-1"}],["path",{"d":"M5 15h5m4 0h7","key":"svg-2"}],["path",{"d":"M3 20h9m4 0h3","key":"svg-3"}]]

/**
 * IconMist
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWlzdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNSA1aDNtNCAwaDkiIC8+CiAgPHBhdGggZD0iTTMgMTBoMTFtNCAwaDEiIC8+CiAgPHBhdGggZD0iTTUgMTVoNW00IDBoNyIgLz4KICA8cGF0aCBkPSJNMyAyMGg5bTQgMGgzIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/mist
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMist = createReactComponent('outline', 'mist', 'Mist', __iconNode);

export default IconMist;